export const lifetimeDailyTooltip = (description: string, from?: string | null, to?: string | null): string =>
  `${description}. Available lifetime history: ${from?.split('T')[0] ?? 'unknown'} to ${to?.split('T')[0] ?? 'unknown'}. Includes previous owners' operation. Driving days above 1 km only.`;
